"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dismissAnnouncement = exports.announcementsReducer = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const models_1 = require("@creature-chess/models");
// Bound the queue so a flurry of upgrades can't grow it without limit.
const MAX_ANNOUNCEMENTS = 20;
// The gamemode emits level-up/streak events for every level and every streak
// change, these decide which are worth surfacing as a banner announcement.
// Level 2 is reached almost instantly every game, so it's not announced.
const ANNOUNCE_LEVEL = (level) => level !== 2;
const ANNOUNCE_STREAK = (amount) => [3, 5, 10].includes(amount);
const initialState = { items: [], nextId: 0 };
const slice = (0, toolkit_1.createSlice)({
    name: "announcements",
    initialState,
    reducers: {
        // Drop an announcement once it has finished scrolling past.
        dismissAnnouncement: (state, { payload: id }) => {
            state.items = state.items.filter((item) => item.id !== id);
        },
    },
    extraReducers: (builder) => {
        const push = (state, announcement) => {
            state.items.push(announcement);
            state.nextId += 1;
            if (state.items.length > MAX_ANNOUNCEMENTS) {
                state.items.splice(0, state.items.length - MAX_ANNOUNCEMENTS);
            }
        };
        builder
            .addMatcher(models_1.GameEvents.pieceUpgradedEvent.match, (state, { payload: { playerId, definitionId, stage } }) => {
            push(state, {
                id: state.nextId,
                kind: "upgrade",
                playerId,
                definitionId,
                stage,
            });
        })
            .addMatcher(models_1.GameEvents.playerLevelUpEvent.match, (state, { payload: { playerId, level } }) => {
            if (!ANNOUNCE_LEVEL(level)) {
                return;
            }
            push(state, { id: state.nextId, kind: "levelUp", playerId, level });
        })
            .addMatcher(models_1.GameEvents.playerStreakEvent.match, (state, { payload: { playerId, streakType, streakAmount } }) => {
            if (!ANNOUNCE_STREAK(streakAmount)) {
                return;
            }
            push(state, {
                id: state.nextId,
                kind: "streak",
                playerId,
                streakType,
                streakAmount,
            });
        })
            .addMatcher(models_1.GameEvents.playerEliminatedEvent.match, (state, { payload: { playerId } }) => {
            push(state, { id: state.nextId, kind: "eliminated", playerId });
        });
    },
});
exports.announcementsReducer = slice.reducer;
exports.dismissAnnouncement = slice.actions.dismissAnnouncement;
